import React from 'react';
import './CustomButton.css'; 

function CustomButton({ onClick, children, className, style, icon }) {
  return (
    <button 
      onClick={onClick} 
      className={`custom-button ${className}`} 
      style={style}
    >
      {icon && <img src={icon} alt="icon" className="button-icon" />}  
      {children}
    </button>
  );
}

export default CustomButton;
